import { render, staticRenderFns } from "./ProductImageAlt.vue?vue&type=template&id=cb261210&"
import script from "./ProductImageAlt.vue?vue&type=script&lang=ts&"
export * from "./ProductImageAlt.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports